import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import SimpleTableWithSorting, {
  generateColumn,
} from '../common/SimpleTableWithSorting';

const getPromoCodesColumns = () => [
  generateColumn('promo_code', { customHeader: i18next.t('admin-promo-codes-statistics.code-name') }),
  generateColumn('orders_count', { customHeader: i18next.t('admin-promo-codes-statistics.orders-count') }),
  generateColumn('issuer', { customHeader: i18next.t('admin-promo-codes-statistics.issuer') }),
  generateColumn('refund_amount', { customHeader: i18next.t('admin-promo-codes-statistics.value') }),
];

interface IProps {
  data: {
    promo_code: string;
    orders_count: number;
    issuer: string;
    refund_amount: number;
  }[];
}

const AdminPromoCodesStatistics = ({ data }: IProps) => {
  return (
    !!data && <SimpleTableWithSorting columns={getPromoCodesColumns()} data={data} />
  );
};

AdminPromoCodesStatistics.propTypes = {
  data: PropTypes.array,
};

export default AdminPromoCodesStatistics;
